import React from 'react';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { forwardTo } from '../../helpers'
import './header.css';
import { isWebpSupported } from 'react-image-webp/dist/utils';

/* ICONS */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faHome, faPlusCircle, faSignOutAlt, faList, faMapMarked, faExclamationCircle, faPoll, faHandHoldingUsd, faGlobe, faCheckCircle, faSpinner, faVoteYea, faUserEdit } from '@fortawesome/free-solid-svg-icons'
/* ICONS */

import { useTranslation } from 'react-i18next';
import { incidentsActions } from './../../actions/incidents.actions';

export const Header = props => {
  const { users, dispatch, entity } = props;
  const { t, i18n } = useTranslation();

  const logOut = () => {
    dispatch(incidentsActions.clearIncidents());
    forwardTo('/login')
  }


  const getUserToken = () => users?.user?.shortToken || '';

  const getUserIdiomaID = () => {
    const lngFull = (i18n && i18n.language) || 'es';
    const lng = (lngFull || 'es').toLowerCase().split('-')[0]; // ca-ES -> ca
    return (lng === 'ca') ? 'cat' : lng;
  };


  const applyPlaceholders = (urlTemplate) => {
    const token = encodeURIComponent(getUserToken());

    let idiomaRaw = getUserIdiomaID() || 'es';
    if (idiomaRaw === 'ca') idiomaRaw = 'cat';

    const idioma = encodeURIComponent(idiomaRaw);

    return (urlTemplate || '')
      .replaceAll('<@token@>', token)
      .replaceAll('<@idiomaID@>', idioma);
  };


  const toPortalLoginUrl = (finalUrl) => {
    const u = new URL(finalUrl);

    // construye ReturnUrl como "/frmP1.aspx?...." (path + query)
    const inner = u.pathname + u.search;

    // encode ReturnUrl y fuerza %xx en minúscula como tu ejemplo "que funciona"
    const returnUrlEnc = encodeURIComponent(inner).replace(/%[0-9A-F]{2}/g, m => m.toLowerCase());

    // repite query externa EXACTA
    const outerQuery = u.search ? `&${u.search.substring(1)}` : '';

    return `https://portal.gecorcloud.com/login.aspx?ReturnUrl=${returnUrlEnc}${outerQuery}`;
  };

  const openTemplateUrl = (urlTemplate) => {
    const finalUrl = applyPlaceholders(urlTemplate);

    // si es portal.gecorcloud.com y NO es login.aspx, lo envolvemos
    try {
      const u = new URL(finalUrl);
      const isPortal = u.hostname === 'portal.gecorcloud.com';
      const isLogin = u.pathname.toLowerCase() === '/login.aspx';

      const urlToOpen = (isPortal && !isLogin) ? toPortalLoginUrl(finalUrl) : finalUrl;
      window.open(urlToOpen, '_blank', 'noopener,noreferrer');
    } catch {
      // fallback
      window.open(finalUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleLogoClick = () => {
    // Si estamos en login, queremos forzar el buscador de ayuntamientos (ao=0)
    if (window.location.pathname.startsWith('/login')) {
      forwardTo('/login?ao=0');
    } else {
      forwardTo('/');
    }
  };


  return (
    <div id="header">
      <Navbar collapseOnSelect className="menu" sticky="top" expand="lg">
        {entity && entity.LogoWebCiudadanos ?
          <Navbar.Brand className="iconBrand_143" target="_blank" rel="noopener noreferrer" onClick={handleLogoClick}>
            <img alt="icon" className="img-header_206" src={entity.LogoWebCiudadanos} />
          </Navbar.Brand>
          :
          <Navbar.Brand className="iconBrand pointer" target="_blank" rel="noopener noreferrer" >
            <Nav.Link onClick={handleLogoClick}><img alt="imagen header" className="img-header" src={isWebpSupported() ? "https://gecorcloud.com/images/FooterLogo.webp" : "https://gecorcloud.com/images/FooterLogo.png"} /></Nav.Link>
          </Navbar.Brand>
        }

        <Navbar.Toggle className="buttomToggle" aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
          </Nav>
          <Nav className="menu2" >
            {/* Botón Inicio siempre visible */}
            <Nav.Link onClick={() => forwardTo('/')}><FontAwesomeIcon icon={faHome} />{t("nav.nav1")}</Nav.Link>
            {/* 🔒 Menú completo solo si AO abierto al ciudadano */}
            { (entity?.AbiertoParaElCiudadano == 1 || entity?.AyuntamientoID !== 6) && (
              <> {users.loggedIn &&
                <Nav.Link onClick={() => forwardTo('/surveys')}>{<><FontAwesomeIcon icon={faPoll} />{t("survey.p1")}</>}</Nav.Link>
              }
                {users.loggedIn && entity?.AyuntamientoID === 10449 && (
                  <NavDropdown className="expadir-menu" title={<><FontAwesomeIcon icon={faHandHoldingUsd} />{t("nav.nav14")}</>} id="nav-presupuestos-participativos" >
                    <NavDropdown.Item onClick={() => openTemplateUrl('https://portal.gecorcloud.com/frmP1.aspx?Constante=37023&token=<@token@>&idioma=<@idiomaID@>')} >
                      <FontAwesomeIcon icon={faGlobe} /> {t("nav.nav14-1")}
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => openTemplateUrl('https://portal.gecorcloud.com/frmP1.aspx?Constante=37027&token=<@token@>&idioma=<@idiomaID@>')} >
                      <FontAwesomeIcon icon={faUserEdit} /> {t("nav.nav14-2")}
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => openTemplateUrl('https://portal.gecorcloud.com/frmP1.aspx?Constante=37028&token=<@token@>&idioma=<@idiomaID@>')} >
                      <FontAwesomeIcon icon={faVoteYea} /> {t("nav.nav14-3")}
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => openTemplateUrl('https://portal.gecorcloud.com/frmP1.aspx?Constante=37030&token=<@token@>&idioma=<@idiomaID@>')} >
                      <FontAwesomeIcon icon={faSpinner} /> {t("nav.nav14-4")}
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => openTemplateUrl('https://portal.gecorcloud.com/frmP1.aspx?Constante=37031&token=<@token@>&idioma=<@idiomaID@>')} >
                      <FontAwesomeIcon icon={faCheckCircle} /> {t("nav.nav14-5")}
                    </NavDropdown.Item>
                  </NavDropdown>
                )}

                {users.loggedIn &&
                  <NavDropdown className="expadir-menu" title={<><FontAwesomeIcon icon={faExclamationCircle} />{t("nav.navInc")}</>} id="basic-nav-dropdown">
                    <NavDropdown.Item onClick={() => forwardTo('/new-incident')}><FontAwesomeIcon icon={faPlusCircle} />{t("nav.nav6-1")}</NavDropdown.Item>
                    <NavDropdown.Item onClick={() => forwardTo('/incidents')}><FontAwesomeIcon icon={faList} />{t("nav.nav6-2")}</NavDropdown.Item>
                    <NavDropdown.Item onClick={() => forwardTo('/nearby')}><FontAwesomeIcon icon={faMapMarked} />{t("nav.nav6-3")}</NavDropdown.Item>
                  </NavDropdown>
                }
                {!users.loggedIn ?
                  <Nav.Link onClick={() => forwardTo('/login')}><FontAwesomeIcon icon={faUser} /> {t("nav.nav5")} </Nav.Link>
                  :
                  <NavDropdown className="expadir-menu" title={<><FontAwesomeIcon icon={faUser} />{t("nav.nav6")}</>} id="basic-nav-dropdown">
                    <NavDropdown.Item onClick={() => forwardTo('/settings')}>{t("nav.nav6-4")}</NavDropdown.Item>
                    <NavDropdown.Item onClick={logOut}><FontAwesomeIcon icon={faSignOutAlt} />{t("nav.nav6-5")}</NavDropdown.Item>
                  </NavDropdown>
                }

                <Nav.Link className="nuevo-aviso" onClick={() => forwardTo('/new-incident')}><FontAwesomeIcon icon={faPlusCircle} />{t("nav.nav7")}</Nav.Link>
              </>)}
          </Nav>
        </Navbar.Collapse>
      </Navbar>

    </div>
  );
}

export default Header;